<div class="trinka_cloud_wrap">

    <div class="trinka_cloud_wrap1">
        <div class="cloud_top_banners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="trinka_cloud_banner_text">
                            <h1>引文檢查器</h1>
                            <h2>加強你的研究論證</h2>
                            <p>Trinka引文檢查器進行自動引文分析，以識別可能削弱您研究假設和論證的引文，並幫助您為您的論文引用可信的、權威的引文。</p>
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" id="autoEditGetStart" target="_blank">立刻查看</a>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                            <img src="../../../assets/images/Reference-Quality-Check.png" alt="Citation Checker">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="how_it_work_section" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>How It Works</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="register">
                                </div>
                                <h3>Register / Login</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="import file">
                                </div>
                                <h3>Select auto file edit <br />& upload your file</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="improve">
                                </div>
                                <h3>Download file with<br /> track changes </h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/citation-video.png" alt="citation checker thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何運作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">請看Trinka引文檢查器是如何工作的，起動快速。</p>
                        <p style="margin-bottom: 10px;">簡單的操作影片將説明您最有效地利用這一功能。</p>
                        <p>更多問題？ <a style="color: #0000ff;" (click)="scroll(target)" class="link">請在</a>這裡瀏覽我們的常見問題。</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka引文檢查器的主要特點</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka引文檢查器可以識別各種品質風險，進行有力的引文分析，讓您改進參考文獻列表，加強研究論證。</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Retracted-References.png" alt="Retracted References">
                        <h3>被撤稿的引文</h3>
                        <p>識別出版後被撤稿的研究，避免同行評審的批評。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Non-standard-References.png" alt="non standard">
                        <h3>非標準引文</h3>
                        <p>排除未經同行評審的研究來提高您引文可信度。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/low-visibility.png" alt="low visibility">
                        <h3>低能見度引文</h3>
                        <p>找出未被其他作者頻繁引用的引文，避免削弱您論證力度。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Old-References.png" alt="old reference">
                        <h3>舊參考資料</h3>
                        <p>輕鬆識別很久以前發表的論文，以確保您引文的高度相關性和有效性。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 dflex">
                    <div class="features_cards c-card">
                        <img src="../../../assets/images/Overuse.png" alt="overuse">
                        <h3>過度使用特定期刊</h3>
                        <p>識別對特定期刊的不經意的過度引用，以使您的引文來源多樣化以避免同行評審的批評。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>為什麼選擇Trinka引文檢查器</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker rchecker">
                        <div class="media">
                            <div class="media-left">
                                <img src="../../../../assets/images/languageScore_icon.svg" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>免費引文分數</h3>
                                <p>免費生成引文分析得分，讓您視需要購買引文報告。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="c-card trinka-checker">
                        <div class="media">
                            <div class="media-left">
                                <img src="../../../../assets/images/Up-to-date-Repository.png" alt="Free Score Overview" />
                            </div>
                            <div class="media-body">
                                <h3>Crossref驗證</h3>
                                <p>您的所有引文都會根據Crossref廣泛的出版物資料庫進行驗證，該資料庫受到全世界出版商和組織的信任。</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="key_features_heading">
                        <h2>查看報告樣本</h2>
                        <div class="HeadingSubLine"></div>
                        <p>請見Trinka引文檢查器的引文分析報告樣本，瞭解您如何能從中改善您的論文</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="citation-checker/sample-report/">查看完整報告 <i class="fa fa-arrows-alt" aria-hidden="true"></i></a>
                        <img src="../../../assets/images/citation-report.jpg" alt="citation report">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>現在就獲取您的免費引文分析得分</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">立刻開始</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>引文檢查器使用積分</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/credits_icon.png" alt="">
                            </span>
                            <p>引文分析分數是免費的；您僅為完整的報告付費。為了生成報告，1個積分最多可用於10條引文。使用免費分數或根據需要購買更多分數。</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 0px;">積分類似於代幣，可以讓你根據需要使用Trinka的一些功能。</p>
                            <p>高級用戶每月可獲得10個免費點數，基本用戶每月可獲得4個免費點數。欲瞭解更多，<a [routerLink]="['/features/credits']">請點擊這裡</a>。</p>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Free Credits Available</h3>
                        </div>
                        <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Credits Consumed</h3>
                        </div>
                        <p>Auto File Edit uses 1 credit for every 5000 words. You may upload larger files; credits required will be shown and consumed accordingly. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="CreditBoxTrinka">
                        <div class="card_overlay"></div>
                        <div class="CreditBoxTrinkaHeader">
                            <h3>Buy More Credits</h3>
                        </div>
                        <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常見問題</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka引文檢查器是如何運作的？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>透過3個簡單的步驟提高您的引文品質!</h4>
                                        <ol>
                                            <li>僅需在Trinka上<a href="https://cloud.trinka.ai/signup" target="_blank">免費註冊</a>。</li>
                                            <li>從左邊的導航面板轉到引文檢查器頁面。</li>
                                            <li>上傳你的文件。你可以從Google Drive、OneDrive、Dropbox或你的電腦上傳。您也可以使用已經上傳至Trinka的文件。您將在幾分鐘內獲取您的報告!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        在哪裡可以訪問Trinka引文檢查器？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka引文檢查器功能目前只在Trinka雲端平台上使用。它很快也會出現在Word外掛程式中。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Trinka可否審閱對付費文章的引用？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。我們可以對您的引文進行品質檢查，即使這些引文是發表在付費期刊上。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以與我的合著者分享引文報告嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>目前報告是不可分享的。近期內就可以做到。 </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>


    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/wordplugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br />外掛程式</h3>
                                        </div>
                                </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                            <h3>瀏覽器
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['/enterprise']">
                                        <div class="app_name_content" style="padding: 0px;">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                            <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                            <span style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>